// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 253 ? "EndCallScreen" : chunkId) + "." + {"253":"26e91c06","787":"9cf6036f"}[chunkId] + ".chunk.js";
};